import { Box } from "@mui/material";
import { ReactComponent as Typ1SymbolIcon } from "components/icons/iconsSvg/Typ1Symbol.svg";
import { ReactComponent as Typ2SymbolIcon } from "components/icons/iconsSvg/Typ2Symbol.svg";
import ProcessOption from "./ProcessOption";
import { translations } from "translations";

export interface SelectGridFormingTypeProps {
  setGridFormingType: React.Dispatch<React.SetStateAction<number>>;
  gridFormingType: number;
}

const SelectGridFormingType: React.FC<SelectGridFormingTypeProps> = ({ setGridFormingType, gridFormingType }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "2rem",
        flex: "1 0 0",
      }}
    >
      <ProcessOption
        active={gridFormingType === 1}
        setProcessOption={() => setGridFormingType(1)}
        icon={<Typ1SymbolIcon width="2.5rem" height="2.5rem" />}
        title={translations.pages.certificateUpload.gridFormingTypeSelection.type1.title}
        description={translations.pages.certificateUpload.gridFormingTypeSelection.type1.description}
      />
      <ProcessOption
        active={gridFormingType === 2}
        setProcessOption={() => setGridFormingType(2)}
        icon={<Typ2SymbolIcon width="2.5rem" height="2.5rem" />}
        title={translations.pages.certificateUpload.gridFormingTypeSelection.type2.title}
        description={translations.pages.certificateUpload.gridFormingTypeSelection.type2.description}
      />
    </Box>
  );
};

export default SelectGridFormingType;
